import { gql } from "@apollo/client";

const EVENTO_FIELDS = gql`
  fragment ConfiguracionEventoFields on EventoComedor {
    id nombre inicio fin inicioArgentina finArgentina activo menuUniversitario menuUniversitarioPrecio
    bloqueaMenu bloqueaCafeteria bloqueaAppCompleta mensajeBloqueo idComandera mediosPago updatedAt
  }
`;

const CONFIGURACION_FIELDS = gql`
  fragment ConfiguracionEventoCompletaFields on ConfiguracionEventoComedor {
    evento { ...ConfiguracionEventoFields }
    tieneVentas ultimaVentaArgentina idsProductosConVentas
    productos {
      idProducto precioEvento orden habilitado
      producto { id nombre precioCarta categoriaProducto { id categoria } }
    }
  }
`;

export const CONFIGURACION_EVENTOS = gql`
  query configuracionEventosComedor($search: String, $order: Order, $pagination: PaginationInput) {
    paginationInfo { pages total }
    configuracionEventosComedor(search: $search, order: $order, pagination: $pagination) { ...ConfiguracionEventoFields }
  }
  ${EVENTO_FIELDS}
`;

export const CONFIGURACION_EVENTO = gql`
  query configuracionEventoComedor($id: ID!) {
    configuracionEventoComedor(id: $id) { ...ConfiguracionEventoCompletaFields }
  }
  ${EVENTO_FIELDS}
  ${CONFIGURACION_FIELDS}
`;

export const OPCIONES_CONFIGURACION_EVENTO = gql`
  query opcionesConfiguracionEventoComedor {
    opcionesConfiguracionEventoComedor {
      sede { id nombre }
      mediosPago { codigo etiqueta requiereConfirmacionVendedor recomendado }
      comanderas { id printName habilitado estadoConexion }
      idComanderaPredeterminada
    }
  }
`;

export const DIAGNOSTICO_CONFIGURACION_EVENTO = gql`
  query diagnosticoConfiguracionEventoComedor($input: DiagnosticoConfiguracionEventoInput!) {
    diagnosticoConfiguracionEventoComedor(input: $input) {
      dias
      truncado
      eventosSolapados { id nombre inicioArgentina finArgentina }
      categoriaMenuEncontrada
      turnosActivos
      diasSinMenu
      vouchersFisicos {
        idVoucher idGrupo grupo tipo producto categoria valorPapel presupuesto desde hasta problema
      }
    }
  }
`;

export const GUARDAR_CONFIGURACION_EVENTO = gql`
  mutation guardarConfiguracionEventoComedor($input: ConfiguracionEventoComedorInput!) {
    guardarConfiguracionEventoComedor(input: $input) { ...ConfiguracionEventoCompletaFields }
  }
  ${EVENTO_FIELDS}
  ${CONFIGURACION_FIELDS}
`;

export const CAMBIAR_ACTIVO_EVENTO = gql`
  mutation cambiarActivoEventoComedor($id: ID!, $activo: Boolean!) {
    cambiarActivoEventoComedor(id: $id, activo: $activo) { ...ConfiguracionEventoFields }
  }
  ${EVENTO_FIELDS}
`;

export const EXTENDER_FIN_EVENTO = gql`
  mutation extenderFinEventoComedor($id: ID!, $fin: String!, $activar: Boolean) {
    extenderFinEventoComedor(id: $id, fin: $fin, activar: $activar) { ...ConfiguracionEventoFields }
  }
  ${EVENTO_FIELDS}
`;

export const ELIMINAR_CONFIGURACION_EVENTO = gql`
  mutation eliminarConfiguracionEventoComedor($id: ID!) {
    eliminarConfiguracionEventoComedor(id: $id)
  }
`;

export const PRODUCTOS_CONFIGURACION_EVENTO = gql`
  query productosConfiguracionEvento($filter: JSON, $search: String, $page: Int!, $limit: Int!) {
    paginationInfo { pages total }
    productos(
      filter: $filter
      search: $search
      pagination: { page: $page, limit: $limit }
      order: { field: "nombre", order: ASC }
    ) {
      id nombre precioCarta disponibilidad
      categoriaProducto { id categoria }
    }
  }
`;

export const CATEGORIAS_CONFIGURACION_EVENTO = gql`
  query categoriasConfiguracionEvento {
    categoriasProducto(order: { field: "categoria", order: ASC }) { id categoria }
  }
`;
